<template>
  <div>
    <div class="px-2 pt-2 d-flex justify-center"> 
      <v-chip-group show-arrows center-active style="max-width: 100%;">
        <v-chip
          :color="(!Category || Category == 'undefined') ? '#3EA56E' : '#ffffff'"
          :text-color="(!Category || Category == 'undefined') ? '#ffffff' : '#3EA56E'"
          :style="(!Category || Category == 'undefined') ? 'border: 1px solid #3EA56E; height: 32px; border-radius: 16px;' : 'border: 1px solid #e2e8f0; height: 32px; border-radius: 16px;'"
          class="font-weight-bold px-4"
          @click="changeRoute('All')"
        >
          All
        </v-chip>
        <v-chip
          v-for="(item, i) in subCategories"
          :key="i"
          :color="$route.query.Category == item.urlname ? '#3EA56E' : '#ffffff'"
          :text-color="$route.query.Category == item.urlname ? '#ffffff' : '#3EA56E'"
          :style="$route.query.Category == item.urlname ? 'border: 1px solid #3EA56E; height: 32px; border-radius: 16px;' : 'border: 1px solid #e2e8f0; height: 32px; border-radius: 16px;'"
          class="font-weight-bold px-4"
          @click="changeRoute(item)"
        >
          {{ item.name }}
        </v-chip>
      </v-chip-group>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      subCategories: [],
      mainCategoryId: null,
      categoryId: null,
      Category: null,
    };
  },
  beforeMount() {
    this.Category = this.$route.query.Category
        this.mainCategoryId = this.mainCat;
        this.categoryId = this.getCat;
    this.getSubCategory();
    //  this.get();
  },

   computed: {
    mainCat() {
      return this.$store.state.SelectedIDS.MainCatId;
    },
    getCat() {
      return this.$store.state.SelectedIDS.CatId;
    },
  },
  methods: {
    getSubCategory() { 
      this.appLoading = true;
      axios({
        method: "post",
        url: "/category/getlist",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          maincategoryname:this.$route.params.MainCategory
          // mainCategoryId: this.mainCategoryId
        }
      })
        .then((response) => {
          this.appLoading = false;
          this.subCategories = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    changeRoute(item) {
      localStorage.setItem("categoryId", item._id);
      this.$store.commit("updateCatId",  item._id);
      if(item=='All') {
      localStorage.setItem("categoryId", "");
         this.$router.push({
        path: "/products/" + (this.$route.params.MainCategory || ''),
        query: {
          Category: ''
        },
      });
      } 
      else {
         this.$router.push({
        path: "/products/" + (this.$route.params.MainCategory || ''),
        query: {
          Category: item.urlname
        },
      });
      this.Category = this.$route.query.Category
      }
     
    },
  },
};
</script>
<style scoped>
.v-chip {
  transition: all 0.3s ease;
}
.v-chip:hover {
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.15);
}
</style>